import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UsersService} from '../../api/users.service';
import {FilterStorageService} from '../../services/filter-storage.service';
import {AddUserRequestModel} from '../../api/add-user-request-model';
import { showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

@Component({
  selector: 'app-user-add',
  templateUrl: './user-add.component.html',
  styleUrls: ['./user-add.component.scss']
})
export class UserAddComponent implements OnInit {
  user: AddUserRequestModel;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private users: UsersService,
              private filters: FilterStorageService) { }

  ngOnInit() {
    this.user = new AddUserRequestModel();
    this.user.appFeatures = '[SCALE,BASE,PHONE,EMAIL,PHOTO,ALLGUESTS,SOCIAL]';
  }

  async saveData() {
    if (!this.user.roleId){
      alert('Select role');
      return ;
    }

    showSpinner(document.getElementById('wrapper')) ;

    this.user.executorId = 'notemptystring';

    try {
      await this.users.add(this.filters.getSelectedOrganization().id, this.user).toPromise();
      this.goBack();
    } catch (e) {
      alert(e.error.message);
      console.error(e);
    } finally {
      hideSpinner(document.getElementById('wrapper'));
    }
  }

  goBack() {
    this.router.navigate(['..'], {relativeTo: this.route});
  }
}
